export const siteLocationIntegers = [];
export const siteLocationFloats = [];
export const siteLocationIsoStrings = [];
export const siteLocationWhiteList = ['id', 'name', 'siteId', 'siteLocationType'];
export const siteLocationOptimisticList = [...siteLocationWhiteList];
